// extracted by mini-css-extract-plugin
export default {"accordionHeader":"accordion-item_accordionHeader__q7FRT"};